import { render, staticRenderFns } from "./SummaryModal.vue?vue&type=template&id=2b236446&scoped=true&"
import script from "./SummaryModal.vue?vue&type=script&lang=js&"
export * from "./SummaryModal.vue?vue&type=script&lang=js&"
import style0 from "./SummaryModal.vue?vue&type=style&index=0&id=2b236446&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b236446",
  null
  
)

export default component.exports